declare module "iron-session" {
  interface IronSessionData {
    token?: any;
  }
}

import { setAccessToken } from "./cookieHelper";
import { withIronSessionApiRoute } from "iron-session/next";
import { sessionOptions } from "./session";
import { nextCsrf } from "next-csrf";
import { csrf } from "./csrf";

const nextLogin = withIronSessionApiRoute(async (req, res) => {
  if (req.method === "POST") {
    const { accessToken } = req.body;

    try {
      res.setHeader("Set-Cookie", [
        setAccessToken(accessToken["access_token"]),
      ]);
      res.setHeader("Content-Type", "application/json");
      req.session.token = accessToken;
      res.send(JSON.stringify(accessToken));
    } catch (error) {
      return res.status(422).json(error);
    }
  }
}, sessionOptions);

export default nextLogin;
